@if (svg(); as container) {
  <div
    class="size-full fill-[var(--faculty-600,black)]!"
    [innerHTML]="container"
  ></div>
}
